import { render } from "./project-view.vue?vue&type=template&id=20d5a690"
import script from "./project-view.vue?vue&type=script&lang=js"
export * from "./project-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__